import { render, staticRenderFns } from "./ImsSentToEcnsModal.vue?vue&type=template&id=40437480&"
import script from "./ImsSentToEcnsModal.vue?vue&type=script&lang=js&"
export * from "./ImsSentToEcnsModal.vue?vue&type=script&lang=js&"
import style0 from "./ImsSentToEcnsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports